import { render } from "./TablaTotalesCentroBorrador.vue?vue&type=template&id=c14b3e4a"
import script from "./TablaTotalesCentroBorrador.vue?vue&type=script&lang=js"
export * from "./TablaTotalesCentroBorrador.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__